import { ActionIcon, Box, Tooltip } from '@mantine/core';
import { IconDownload, IconX } from '@tabler/icons';
import { useEffect, useState } from 'react';
import PdfPreview from '../../Molecules/Document/PdfPreviewNew';
import { FileS } from '../../Service/FileS';
import EmailAttachmentChip from './EmailAttachmentChip';

const EmailFileAttachment = ({ downloadable = false, attachment, eventId, index, deleteAtIndex }) => {
  const [fileExists, setFileExists] = useState(true);
  const { entityId, entityType, fileName } = attachment;

  useEffect(() => {
    if (entityType === 'profiles') {
      FileS.isFileExists(entityType, entityId, fileName).then(setFileExists);
    }
  }, [entityType, entityId, fileName]);

  return (
    <Tooltip
      withArrow
      color="red"
      disabled={fileExists}
      label="Datei nicht gefunden"
      position="right"
      transition="slide-right"
    >
      <EmailAttachmentChip missing={!fileExists}>
        <Box sx={{ flex: '0 1 auto', minWidth: 0, maxWidth: '100%', overflow: 'hidden' }}>
          <PdfPreview
            eventId={eventId}
            file={attachment}
            fileExists={fileExists}
            fileNameWidth={200}
            fileNameSize="xs"
          />
        </Box>
        {downloadable && fileExists && (
          <ActionIcon
            size="xs"
            sx={{ flex: '0 0 auto' }}
            title="Herunterladen"
            onClick={() => FileS.downloadFile(entityType, entityId, fileName)}
          >
            <IconDownload />
          </ActionIcon>
        )}
        {deleteAtIndex && (
          <ActionIcon size="xs" sx={{ flex: '0 0 auto' }} title="Anhang entfernen" onClick={() => deleteAtIndex(index)}>
            <IconX />
          </ActionIcon>
        )}
      </EmailAttachmentChip>
    </Tooltip>
  );
};

export default EmailFileAttachment;
